exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".custom-range-date{position:absolute;z-index:9999;top:-30%;left:104%;padding-left:20px;width:580px;height:330px}.custom-range-date .custom-group label{line-height:27px}.custom-range-date .custom-group .custom-input input{height:36px}.custom-range-date .custom-group .custom-input-to.rdtOpen .rdtPicker{top:-128%}.custom-range-date .rdtOpen .rdtPicker{position:absolute;top:0;left:100%}.custom-range-date .rdtOpen .rdtPicker:before,.custom-range-date .rdtOpen .rdtPicker:after{content:none}.custom-range-date .rdt .rdtPicker{transition:none}@media screen and (max-width: 767px){.custom-range-date{left:-4%;width:108%}}.custom-range-date.responsive{left:auto;right:104%}@media screen and (max-width: 767px){.custom-range-date.responsive{left:-4%;width:108%}}.custom-range-date:after{clear:both}.custom-item{position:relative}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/date-range/style.scss
// module id = 1985
// module chunks = 35